import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["data-epochid"]
const _hoisted_2 = { class: "moment__container" }
const _hoisted_3 = { class: "moment__image" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 1,
  class: "moment__no-image-container"
}
const _hoisted_6 = { class: "moment__text" }
const _hoisted_7 = { class: "moment__text-top" }
const _hoisted_8 = { class: "moment__year" }
const _hoisted_9 = { class: "moment__title" }
const _hoisted_10 = { class: "moment__description" }

import { computed } from "vue";
import type { ITimelineMapItem } from "../../interfaces/ITimelineMapItem";
import { useTimelineMapStore } from "@features/Pages/TimelineMapPage/_js/app/store/timelineMapStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'MomentVRAK',
  props: {
    moment: {},
    epochId: {},
    translations: {}
  },
  setup(__props: any) {

const props = __props;

const store = useTimelineMapStore();
const isMoment = computed(() => props.moment.type === "Moment");

function onClick() {
  if (isMoment.value) {
    store.onShowModal(props.moment);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["moment", [
      __props.moment.type === 'Moment'
        ? 'moment--type-wreck'
        : 'moment--type-event'
    ]]),
    tabindex: -1,
    onClick: onClick,
    onKeydown: [
      _withKeys(onClick, ["enter"]),
      _withKeys(onClick, ["space"])
    ]
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([
        'timeline-icon',
        __props.moment.type === 'Moment'
          ? 'timeline-icon--vrak-off'
          : 'timeline-icon--event-off'
      ]),
      "data-epochid": __props.epochId
    }, null, 10 /* CLASS, PROPS */, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" Alltid rendera denna "),
      _createElementVNode("div", _hoisted_3, [
        (__props.moment.imageHtml)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              innerHTML: __props.moment.imageHtml
            }, null, 8 /* PROPS */, _hoisted_4))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("span", { class: "moment__no-image-graphic" }, null, -1 /* CACHED */)
            ]))]))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(__props.moment.year), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_9, _toDisplayString(__props.moment.title), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_10, _toDisplayString(__props.moment.momentExcerpt), 1 /* TEXT */)
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "moment__arrow" }, null, -1 /* CACHED */))
      ])
    ])
  ], 34 /* CLASS, NEED_HYDRATION */))
}
}

})